import i18n from "../../i18n"

export const librarySections = () => {
    const t = i18n.getFixedT(i18n.language, 'library')
    return {
        trendingTopics: {
            title: t('Trending Topics'),
            subtitle: t('The most trending knowledge in your organization')
        },
        people: {
            title: t('People'),
            subtitle: t('All the employees of your organization')
        },
        projectGroups: {
            title: t('Project Groups'),
            subtitle: t('Ongoing & archived projects in your organization')
        },
        trendingHashtags: {
            title: t('Trending Hashtags'),
            subtitle: t('Hashtags to follow in the organization')
        },
        dataTypes: {
            title: t('Data Types'),
            subtitle: t('Browse data by types')
        },
        dataGroups: {
            title: t('Data Groups'),
            subtitle: t('Organized data for your usage')
        },
        knowledgeGroups: {
            title: t('Knowledge Groups'),
            subtitle: t('Read more about important updates and shared information')
        },
        mostTrendingItems: {
            title: t('Most recommended items'),
            subtitle: t('View Now'),
            noTitle: t('No recommended items available'),
            noSubtitle: ''
        },
    }
}